import emailjs from "@emailjs/browser";
import React, { useRef, useEffect } from "react";

export default function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // Form ki values lena
    const formData = new FormData(form.current);

    const name = formData.get("user_name");
    const email = formData.get("user_email");
    const phone = formData.get("user_phone");
    const course = formData.get("selected_course");
    const message = formData.get("message");

    // WhatsApp ke liye message
    const whatsappMessage = `
🎓 *New Admission Enquiry*

👤 *Name:* ${name}
📧 *Email:* ${email}
📱 *Contact Number:* ${phone}
📚 *Selected Course:* ${course}
💬 *Message:* ${message || "No message provided"}
`;

    // Tumhara WhatsApp Number
    const whatsappNumber = "919540155567";

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    // EmailJS se email send karna
    emailjs
      .sendForm(
        "service_cmofszj",
        "template_sb11t14",
        form.current,
        "RexhwFQKZg0GgYroB"
      )
      .then(() => {
        // WhatsApp open hoga
        window.open(whatsappURL, "_blank");

        alert("Message Sent Successfully ✅");

        // Form reset
        form.current.reset();
      })
      .catch((error) => {
        console.log(error);

        // Email fail hone par bhi WhatsApp open hoga
        window.open(whatsappURL, "_blank");

        alert(
          "WhatsApp opened successfully. Please click Send on WhatsApp."
        );
      });
  };

  useEffect(() => {
    if (window.location.hash === "#contact-form") {
      setTimeout(() => {
        const element = document.getElementById("contact-form");

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <section className="contact-section">
        <div className="contact-container">

          {/* LEFT */}

          <div className="contact-left">
            <span>
              Contact Us
            </span>

            <h1>
              Let’s Talk About Your Career
            </h1>

            <p>
              Fill out the form and our team will contact
              you shortly regarding admissions and courses.
            </p>

            <div className="contact-strip">

              <div className="strip-item">
                📍 Delhi, India
              </div>

              <div className="strip-item">
                📞 +91 9540155567
              </div>

              <div className="strip-item">
                ✉️ broadwaystrainingservices@gmail.com
              </div>

              <div className="footer-col">
                <div className="social-icons">

                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.facebook.com/share/1DzQhtEDpo/"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>

                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.instagram.com/broadways_training?igsh=eDRta3ZtemVhYnp0"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>

                  <a
                    href="https://wa.me/919540155567"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>

                </div>
              </div>

            </div>
          </div>

          {/* RIGHT */}

          <form
            ref={form}
            onSubmit={sendEmail}
            className="contact-form"
            autoComplete="off"
            id="contact-form"
          >

            {/* NAME */}

            <input
              type="text"
              name="user_name"
              placeholder="Full Name"
              required
            />

            {/* EMAIL */}

            <input
              type="email"
              name="user_email"
              placeholder="Email Address"
              required
            />

            {/* PHONE */}

            <input
              type="text"
              name="user_phone"
              placeholder="Contact Number"
              required
            />

            {/* COURSE DROPDOWN */}

            <select
              name="selected_course"
              required
            >
              <option value="">
                Select Course
              </option>

              <option value="BA">
                BA
              </option>

              <option value="BCom">
                BCom
              </option>

              <option value="BBA">
                BBA
              </option>

              <option value="BCA">
                BCA
              </option>

              <option value="MA">
                MA
              </option>

              <option value="MSc">
                MSc
              </option>

              <option value="MCom">
                MCom
              </option>

              <option value="MBA">
                MBA
              </option>

              <option value="MCA">
                MCA
              </option>

              <option value="MAJMC">
                MAJMC
              </option>
            </select>

            {/* MESSAGE */}

            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
            ></textarea>

            {/* BUTTON */}

            <button type="submit">
              Send Message
            </button>

          </form>

        </div>
      </section>
    </>
  );
}